<template>
  <div class="flex w-full flex-col items-center justify-start">
    <!-- Content Section -->
    <div
        class="flex flex-col w-full max-w-screen-xl items-center justify-start py-10"
    >
      <!-- Featured Businesses -->
      <div class="flex flex-col w-full px-2" v-if="featuredBusinesses?.length > 0">
        <p class="text-xl text-left w-full mb-2">
          <Icon name="mdi:star-circle" />
          Featured Businesses
        </p>
        <div class="grid grid-cols-1 md:grid-cols-4 gap-4 w-full">
          <FeaturedBusinessCard
              class="w-full my-3"
              style="min-height: 250px; height: auto"
              v-for="featuredBusiness in featuredBusinesses"
              :key="featuredBusiness.id"
              :business="featuredBusiness"
              @click.native="gotoBusinessPage(featuredBusiness)"
          />
        </div>
      </div>
      <!-- Featured Businesses Ends -->
      <!-- Latest Businesses -->
      <div class="flex flex-col w-full px-2" v-if="latestBusinesses?.length > 0">
        <p class="text-xl text-left w-full mt-10 mb-2">
          <Icon name="mdi:sort" />
          Latest Businesses
        </p>
        <div class="grid grid-cols-1 md:grid-cols-4 gap-4 w-full">
          <BusinessHomeCard
              class="w-full my-3"
              style="min-height: 250px; height: auto"
              v-for="latestBusiness in latestBusinesses"
              :key="latestBusiness.id"
              :business="latestBusiness"
              @click.native="gotoBusinessPage(latestBusiness)"
          />
        </div>
      </div>
      <!-- Latest Businesses Ends -->
      <!-- Top Rated Businesses -->
      <div class="flex flex-col w-full px-2" v-if="topRatedBusinesses?.length > 0">
        <p class="text-xl text-left w-full mt-10 mb-2">
          <BaseRatingStar />
          Top Rated Businesses
        </p>
        <div class="grid grid-cols-1 md:grid-cols-4 gap-4 w-full">
          <BusinessHomeCard
              class="w-full my-3"
              style="min-height: 250px; height: auto"
              v-for="topRatedBusiness in topRatedBusinesses"
              :key="topRatedBusiness.id"
              :business="topRatedBusiness"
              @click.native="gotoBusinessPage(topRatedBusiness)"
          />
        </div>
      </div>
      <!-- Top Rated Businesses Ends -->
      <!-- Most Viewed Businesses -->
      <div class="flex flex-col w-full px-2" v-if="mostViewedBusinesses?.length > 0">
        <p class="text-xl text-left w-full mt-10 mb-2">
          <Icon name="mdi:eye" />
          Most Viewed Businesses
        </p>
        <div class="grid grid-cols-1 md:grid-cols-4 gap-4 w-full">
          <BusinessHomeCard
              class="w-full my-3"
              style="min-height: 250px; height: auto"
              v-for="mostViewedBusiness in mostViewedBusinesses"
              :key="mostViewedBusiness.id"
              :business="mostViewedBusiness"
              @click.native="gotoBusinessPage(mostViewedBusiness)"
          />
        </div>
      </div>
      <!-- Most Viewed  Businesses Ends -->
      <!-- Latest Reviews -->
      <div class="flex flex-col w-full px-2" v-if="latestReviews?.length > 0">
        <p class="text-xl text-left w-full mt-10 mb-2">
          <Icon name="mdi:message-draw" />
          Latest Reviews
        </p>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
          <BusinessReviewCard
              v-for="latestReview in latestReviews"
              :key="latestReview.id"
              :review="latestReview"
              @click.native="gotoBusinessPage(latestReview.reviewed_for)"
          />
        </div>
      </div>
      <!-- Latest Reviews Ends -->
    </div>
  </div>
</template>
<script setup lang="ts">

import {definePageMeta, useMainBusinessesDataManager} from "#imports";

definePageMeta({
  layout:'main-businesses-home'
});

useHead({
  title: 'Businesses'
})

const mainBusinessesHomeData = await useMainBusinessesDataManager().getBusinessesHome();
const featuredBusinesses =  computed(()=>{
  return mainBusinessesHomeData?.featured_businesses;
});
const latestBusinesses = computed(()=>{
  return mainBusinessesHomeData?.latest_businesses;
});
const topRatedBusinesses =  computed(()=>{
  return mainBusinessesHomeData?.top_rated_businesses;
});
const mostViewedBusinesses = computed(()=>{
  return mainBusinessesHomeData?.most_viewed_businesses;
});
const latestReviews = computed(()=>{
  return mainBusinessesHomeData?.latest_reviews;
});

function gotoBusinessPage(business) {
  navigateTo({
    name: "businesses-slug",
    params: { slug: business.slug },
  });
}

</script>

<style></style>
